"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGroceryCategoryMapMutation = void 0;
const client_1 = require("@apollo/client");
exports.updateGroceryCategoryMapMutation = client_1.gql `
  mutation UpdateGroceryCategoryMap(
    $userId: String!
    $newGroceryCategoryMap: String!
  ) {
    updateGroceryCategoryMap(
      userId: $userId
      newGroceryCategoryMap: $newGroceryCategoryMap
    )
  }
`;
//# sourceMappingURL=UpdateGroceryCategoryMap.js.map